import axios from "axios";
import { handleAxiosErrors, getRessource } from "../utils";

const RADIO = "/radio";
const GET_ZARADIO_BY_CODERESEAU = `${RADIO}/get-ZARadio-by-codeReseau`;
const GET_ELIGIBILITE_RADIO = `${RADIO}/get-eligibilite-radio`;

export const getRadioZaByCodeRadio = (codeReseau, abort) =>
  axios
    .get(GET_ZARADIO_BY_CODERESEAU, {
      params: {
        codeReseau,
      },
      signal: abort.signal,
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));

export const getEligibiliteRadio = (lat, long, abort) =>
  axios
    .get(GET_ELIGIBILITE_RADIO, {
      params: {
        lat,
        long,
      },
      signal: abort.signal,
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));
